import React from 'react';
import { usePortfolioData } from '../data/portfolioData';

export default function CertificationsSection({ onViewAll }) {
  const { data } = usePortfolioData();

  return (
    <div>
      <p className="text-blue-400 font-mono text-sm mb-2 tracking-[0.2em] uppercase">Credentials</p>
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-blue-100">Certifications</h2>
        {onViewAll && (
          <button onClick={onViewAll} className="cta-primary">
            <span>View All</span>
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
          </button>
        )}
      </div>
      <div className="space-y-3">
        {data.certifications.map((c, i) => (
          <div key={c.id} className="card-in group backdrop-blur-2xl bg-slate-900/80 border border-white/10 rounded-xl p-5 hover:bg-blue-500/10 hover:border-blue-400/40 transition-all">
            <div className="flex items-start justify-between gap-4">
              {c.image && (
                <img
                  src={c.image}
                  alt={c.name}
                  className="w-16 h-16 rounded-lg object-cover shrink-0 border border-white/10 mt-0.5"
                  onError={e => { e.target.style.display = 'none' }}
                />
              )}
              <div className="min-w-0 flex-1">
                <h3 className="text-base font-semibold text-blue-300 mb-1 group-hover:text-blue-200">{c.name}</h3>
                {c.provider && <p className="text-xs text-gray-500 mb-1">{c.provider}</p>}
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs text-gray-500">{c.date}</span>
                  {c.credentialUrl && (
                    <>
                      <span className="text-xs text-gray-600">•</span>
                      <a href={c.credentialUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-400/70 hover:text-blue-300 underline underline-offset-2">
                        View Credential
                      </a>
                    </>
                  )}
                </div>
              </div>
              <svg className="w-8 h-8 shrink-0 text-blue-400/30 group-hover:text-blue-400/60 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
        ))}
        {data.certifications.length === 0 && (
          <p className="text-gray-500 text-center py-8">No certifications yet.</p>
        )}
        {onViewAll && (
          <button onClick={onViewAll} className="sm:hidden w-full cta-primary justify-center">
            <span>View All Certifications</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
          </button>
        )}
      </div>
    </div>
  );
}
